/* =========================================================
   YORUKYO — theme.js
   No dependencies. Every effect degrades gracefully and is
   skipped when the visitor prefers reduced motion.
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = window.Yorukyo || { routes: { cartAdd: '/cart/add', cart: '/cart' }, effects: { depixel: true } };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function store(key, value) {
    try {
      if (value === undefined) return window.sessionStorage.getItem(key);
      window.sessionStorage.setItem(key, value);
    } catch (e) { return null; }
  }

  /* ---------------------------------------------------------
     1. Live Tokyo clock (+ "time until 03:14" + 03:14 easter egg)
     --------------------------------------------------------- */
  var tyoFmt = null;
  try {
    tyoFmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Tokyo', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
  } catch (e) { tyoFmt = null; }

  function tokyoParts() {
    if (!tyoFmt) return null;
    var out = {};
    tyoFmt.formatToParts(new Date()).forEach(function (p) { out[p.type] = p.value; });
    var h = out.hour === '24' ? '00' : out.hour;
    return { h: h, m: out.minute, s: out.second };
  }

  function untilText(t) {
    var now = (+t.h) * 3600 + (+t.m) * 60 + (+t.s);
    var target = 3 * 3600 + 14 * 60;
    if (t.h === '03' && t.m === '14') return "It's 03:14 in Tokyo right now.";
    var diff = (target - now + 86400) % 86400;
    var hh = Math.floor(diff / 3600), mm = Math.floor((diff % 3600) / 60);
    return (hh ? hh + 'h ' : '') + mm + 'm until 03:14.';
  }

  function tickClock() {
    var t = tokyoParts();
    if (!t) return;
    $$('[data-tyo-hh]').forEach(function (el) { el.textContent = t.h; });
    $$('[data-tyo-mm]').forEach(function (el) { el.textContent = t.m; });
    $$('[data-tyo-full]').forEach(function (el) { el.textContent = t.h + ':' + t.m + ':' + t.s; });
    $$('[data-tyo-until]').forEach(function (el) { el.textContent = untilText(t); });
    document.documentElement.classList.toggle('is-0314', t.h === '03' && t.m === '14');
  }

  /* ---------------------------------------------------------
     2. Boot screen (home page, once per session)
     --------------------------------------------------------- */
  function boot() {
    var el = $('[data-boot]');
    if (!el) return;
    if (reduceMotion || store('yk-booted')) { el.classList.add('is-done'); return; }
    store('yk-booted', '1');
    document.documentElement.style.overflow = 'hidden';

    var cellsWrap = $('[data-boot-cells]', el);
    var cols = window.innerWidth < 750 ? 6 : 12;
    var rows = Math.ceil(window.innerHeight / (window.innerWidth / cols));
    cellsWrap.style.setProperty('--cols', cols);
    var cells = [];
    for (var i = 0; i < cols * rows; i++) {
      var c = document.createElement('div');
      c.className = 'boot__cell';
      cellsWrap.appendChild(c);
      cells.push(c);
    }

    var lines = $$('.boot__line', el);
    var timers = [];
    var finished = false;

    function finish() {
      if (finished) return;
      finished = true;
      timers.forEach(clearTimeout);
      el.classList.add('is-dissolving');
      // random pixel dissolve
      var order = cells.slice().sort(function () { return Math.random() - 0.5; });
      var batch = Math.ceil(order.length / 10);
      var step = 0;
      var iv = setInterval(function () {
        order.slice(step * batch, (step + 1) * batch).forEach(function (c) { c.classList.add('is-off'); });
        step++;
        if (step * batch >= order.length) {
          clearInterval(iv);
          el.classList.add('is-done');
          document.documentElement.style.overflow = '';
          document.dispatchEvent(new CustomEvent('yk:booted'));
        }
      }, 45);
    }

    lines.forEach(function (line, idx) {
      timers.push(setTimeout(function () { line.classList.add('is-on'); }, 250 + idx * 330));
    });
    timers.push(setTimeout(finish, 250 + lines.length * 330 + 350));

    ['keydown', 'click', 'touchstart'].forEach(function (evt) {
      window.addEventListener(evt, finish, { once: true, passive: true });
    });
  }

  /* ---------------------------------------------------------
     3. Pixel-to-sharp image reveal (canvas, cover-fit)
     --------------------------------------------------------- */
  function depixel(img) {
    var wrap = img.closest('.depixel-wrap');
    if (!wrap || wrap.dataset.depixeled) return;
    wrap.dataset.depixeled = '1';

    function run() {
      var w = wrap.clientWidth, h = wrap.clientHeight;
      if (!w || !h || !img.naturalWidth) return;
      var canvas = document.createElement('canvas');
      canvas.className = 'depixel-canvas';
      canvas.setAttribute('aria-hidden', 'true');
      canvas.width = w; canvas.height = h;
      var ctx = canvas.getContext('2d');
      var small = document.createElement('canvas');
      var sctx = small.getContext('2d');

      // object-fit: cover crop, respecting object-position from CSS
      var iw = img.naturalWidth, ih = img.naturalHeight;
      var scale = Math.max(w / iw, h / ih);
      var sw = w / scale, sh = h / scale;
      var pos = (getComputedStyle(img).objectPosition || '50% 50%').split(' ');
      var px = parseFloat(pos[0]) / 100, py = parseFloat(pos[1] || pos[0]) / 100;
      if (isNaN(px)) px = 0.5; if (isNaN(py)) py = 0.5;
      var sx = (iw - sw) * px, sy = (ih - sh) * py;

      var sizes = [64, 40, 24, 14, 8, 4];
      var i = 0;
      wrap.appendChild(canvas);
      wrap.classList.add('is-depixeling');

      function frame() {
        if (i >= sizes.length) {
          wrap.classList.remove('is-depixeling');
          canvas.remove();
          return;
        }
        var block = sizes[i++];
        small.width = Math.max(1, Math.ceil(w / block));
        small.height = Math.max(1, Math.ceil(h / block));
        sctx.imageSmoothingEnabled = true;
        sctx.drawImage(img, sx, sy, sw, sh, 0, 0, small.width, small.height);
        ctx.imageSmoothingEnabled = false;
        ctx.clearRect(0, 0, w, h);
        ctx.drawImage(small, 0, 0, small.width, small.height, 0, 0, w, h);
        setTimeout(frame, 85);
      }
      try { frame(); } catch (e) { wrap.classList.remove('is-depixeling'); canvas.remove(); }
    }

    if (img.complete && img.naturalWidth) run();
    else img.addEventListener('load', run, { once: true });
  }

  /* ---------------------------------------------------------
     4. Scramble digits on the big 03:14 clock
     --------------------------------------------------------- */
  function scramble(el) {
    if (el.dataset.scrambled) return;
    el.dataset.scrambled = '1';
    var digits = $$('.pixel-clock__d', el);
    var finals = digits.map(function (d) { return d.textContent; });
    var frame = 0;
    el.classList.add('is-scrambling');
    var iv = setInterval(function () {
      frame++;
      digits.forEach(function (d, i) {
        d.textContent = frame > 6 + i * 4 ? finals[i] : String(Math.floor(Math.random() * 10));
      });
      if (frame > 6 + digits.length * 4) {
        clearInterval(iv);
        el.classList.remove('is-scrambling');
      }
    }, 55);
  }

  /* ---------------------------------------------------------
     5. Split heading into letters (screen readers get the full text)
     --------------------------------------------------------- */
  function split(el) {
    var text = el.textContent.trim();
    el.setAttribute('aria-label', text);
    var n = 0;
    el.innerHTML = text.split(' ').map(function (word) {
      return '<span aria-hidden="true" style="display:inline-block;white-space:nowrap">' +
        word.split('').map(function (ch) {
          var safe = ch.replace(/&/g, '&amp;').replace(/</g, '&lt;');
          return '<span class="ch" style="--c:' + (n++) + '">' + safe + '</span>';
        }).join('') + '</span>';
    }).join(' ');
  }

  /* ---------------------------------------------------------
     6. Scroll-triggered reveals
     --------------------------------------------------------- */
  function reveals() {
    var targets = $$('[data-reveal], .js-depixel, [data-scramble]');
    if (reduceMotion || !('IntersectionObserver' in window)) {
      $$('[data-reveal]').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        io.unobserve(el);
        if (el.hasAttribute('data-reveal')) el.classList.add('is-in');
        if (el.classList.contains('js-depixel') && cfg.effects && cfg.effects.depixel) depixel(el);
        if (el.hasAttribute('data-scramble')) scramble(el);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -5% 0px' });
    targets.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------
     7. Header state + hero parallax
     --------------------------------------------------------- */
  function scrollFx() {
    var header = $('.js-header');
    var parallax = reduceMotion ? [] : $$('.js-parallax');
    var ticking = false;
    function update() {
      var y = window.scrollY;
      if (header) header.classList.toggle('is-scrolled', y > 10);
      parallax.forEach(function (el) {
        if (y < window.innerHeight * 1.2) el.style.transform = 'translate3d(0,' + Math.round(y * 0.22 / 4) * 4 + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  /* ---------------------------------------------------------
     8. Toast + pixel sparks
     --------------------------------------------------------- */
  var toastTimer;
  function toast(title, html) {
    var el = $('[data-toast]');
    if (!el) return;
    el.innerHTML = '<p class="toast__title">' + title + '</p><div class="toast__row">' + (html || '') + '</div>';
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.hidden = true; }, 4200);
  }
  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function sparks(x, y) {
    if (reduceMotion) return;
    for (var i = 0; i < 12; i++) {
      var s = document.createElement('span');
      s.className = 'spark';
      var a = (Math.PI * 2 * i) / 12;
      var d = 40 + Math.random() * 40;
      s.style.left = x + 'px'; s.style.top = y + 'px';
      s.style.setProperty('--dx', Math.round(Math.cos(a) * d / 4) * 4 + 'px');
      s.style.setProperty('--dy', Math.round(Math.sin(a) * d / 4) * 4 + 'px');
      document.body.appendChild(s);
      setTimeout(s.remove.bind(s), 700);
    }
  }

  /* ---------------------------------------------------------
     9. Quantity steppers
     --------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.js-qty');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input');
    var min = parseInt(input.min || '0', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.dataset.step, 10));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------------------------------------------------
     10. Product form: variant pills + AJAX add to cart
     --------------------------------------------------------- */
  function productForm(form) {
    var select = $('.js-variant-select', form);
    var addBtn = $('.js-add', form);
    var addLabel = $('.js-add-label', form);
    var dataEl = $('.js-variants', form);
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }
    var fieldsets = $$('.js-option', form);
    var scope = form.closest('section') || document;
    var priceEl = $('[data-price]', scope);
    var isProductPage = !!form.closest('.js-product-page');

    function selectedOptions() {
      return fieldsets.map(function (fs) {
        var checked = $('input:checked', fs);
        return checked ? checked.value : null;
      });
    }

    function findVariant(opts) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0];
    }

    function markUnavailable() {
      // grey out values that have no available variant with the other current selections
      var current = selectedOptions();
      fieldsets.forEach(function (fs, idx) {
        $$('.pill', fs).forEach(function (pill) {
          var val = $('input', pill).value;
          var test = current.slice(); test[idx] = val;
          var v = findVariant(test);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }

    function update() {
      var v = findVariant(selectedOptions());
      if (!v) {
        addBtn.disabled = true;
        addLabel.textContent = 'Unavailable';
        return;
      }
      select.value = String(v.id);
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (priceEl) {
        priceEl.classList.toggle('price--sale', !!v.compare);
        priceEl.innerHTML = v.compare
          ? '<s class="price__compare"><span class="visually-hidden">Regular price</span>' + v.compare + '</s><span class="price__current"><span class="visually-hidden">Sale price</span>' + v.price + '</span>'
          : '<span class="price__current">' + v.price + '</span>';
      }
      if (isProductPage && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      markUnavailable();
    }

    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markUnavailable();

    form.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return; // normal POST fallback
      e.preventDefault();
      addBtn.classList.add('is-loading');
      var rect = addBtn.getBoundingClientRect();

      fetch(cfg.routes.cartAdd + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
        .then(function (r) {
          if (!r.ok) {
            toast('Error', '<span>' + escapeHtml(r.data.description || r.data.message || 'Could not add to cart.') + '</span>');
            return;
          }
          sparks(rect.left + rect.width / 2, rect.top + rect.height / 2);
          var title = r.data.product_title || r.data.title || 'Item';
          var variant = r.data.variant_title && r.data.variant_title !== 'Default Title' ? ' / ' + r.data.variant_title : '';
          toast('Item acquired!', '<span>' + escapeHtml(title + variant) + '</span><a href="' + cfg.routes.cart + '">View cart →</a>');
          return refreshCount();
        })
        .catch(function () { form.submit(); })
        .then(function () { addBtn.classList.remove('is-loading'); });
    });
  }

  function refreshCount() {
    return fetch(cfg.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        var link = $('.cart-link');
        if (link) { link.classList.remove('is-bumped'); void link.offsetWidth; link.classList.add('is-bumped'); }
      })
      .catch(function () {});
  }

  /* ---------------------------------------------------------
     11. Product page thumbnails
     --------------------------------------------------------- */
  function thumbs() {
    var main = $('.js-main-img');
    if (!main) return;
    $$('.js-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        $$('.js-thumb').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        main.removeAttribute('srcset');
        main.src = btn.dataset.src;
        main.alt = btn.dataset.alt || '';
      });
    });
  }

  /* ---------------------------------------------------------
     12. Cart page: auto-update after quantity change
     --------------------------------------------------------- */
  function cartAutoUpdate() {
    var form = $('.cart-form');
    if (!form) return;
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.classList.contains('js-cart-qty')) return;
      clearTimeout(t);
      t = setTimeout(function () {
        var btn = $('.js-cart-update', form);
        if (btn && form.requestSubmit) form.requestSubmit(btn); else if (btn) btn.click();
      }, 700);
    });
  }

  /* ---------------------------------------------------------
     13. Game Boy mode: Konami code, or tap the footer clock 5×
     --------------------------------------------------------- */
  function gameBoyMode() {
    var code = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    var pos = 0;
    function toggle() {
      var on = document.documentElement.classList.toggle('gb');
      toast(on ? 'Game Boy mode' : 'Colour restored', '<span>' + (on ? 'Press it again to switch back.' : 'Welcome back.') + '</span>');
    }
    window.addEventListener('keydown', function (e) {
      var k = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      pos = k === code[pos] ? pos + 1 : (k === code[0] ? 1 : 0);
      if (pos === code.length) { pos = 0; toggle(); }
    });
    var taps = 0, tapTimer;
    $$('.js-gb-tap').forEach(function (el) {
      el.addEventListener('click', function () {
        taps++;
        clearTimeout(tapTimer);
        tapTimer = setTimeout(function () { taps = 0; }, 1500);
        if (taps >= 5) { taps = 0; toggle(); }
      });
    });
  }

  /* ---------------------------------------------------------
     Init
     --------------------------------------------------------- */
  function init() {
    tickClock();
    setInterval(tickClock, 1000);
    if (!reduceMotion) $$('.js-split').forEach(split);
    boot();
    var bootEl = $('[data-boot]');
    if (bootEl && !bootEl.classList.contains('is-done')) {
      document.addEventListener('yk:booted', reveals, { once: true });
    } else {
      reveals();
    }
    scrollFx();
    $$('.js-product-form').forEach(productForm);
    thumbs();
    cartAutoUpdate();
    gameBoyMode();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
